import React from "react";
import styled from "styled-components";

const NavB = styled.div`
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translate(-50%, 0);
  background-color: rgba(0, 0, 0, 0);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 4;
`;

const Button = styled.div`
  padding: 30px 30px;
  > a {
    white-space: nowrap;
    text-decoration: none;
    color: white;
    text-align: center;
    font-weight: 700;
    font-size: 22px;
  }
  &:hover {
    >a{
      font-weight: 700;
      border-bottom: 1px solid #982822;
    }
  }
  &:nth-child(1) {
    padding-left: 60px;
  }
  &:nth-child(6) {
    padding-right: 60px;
  }
`;



function NavBar() {

  return (
    <NavB>
      <Button>
        <a href="#menu">Menus</a>
      </Button>
      <Button>
        <a href="#about">About US</a>
      </Button>
      <Button>
        <a href="#hours">Hours</a>
      </Button>
      <Button>
        <a href="#photos">Photos</a>
      </Button>
      <Button>
        <a href="#contact">Contact</a>
      </Button>
    </NavB>
  );
}

export default NavBar;
